import * as localForage from "localforage";
localForage.setDriver([
    localForage.LOCALSTORAGE,
    localForage.INDEXEDDB,
    localForage.WEBSQL,
]);
var Storage = /*@__PURE__*/ (function () {
    function Storage() {
    }
    Storage.getHelper = function () {
        if (!Storage.storage) {
            Storage.storage = localForage;
        }
        return this.storage;
    };
    Storage.getItem = function (param) {
        return this.getHelper().getItem(param);
    };
    Storage.setItem = function (param, value) {
        return this.getHelper().setItem(param, value);
    };
    return Storage;
}());
export { Storage };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/core/storage/storage.ts
// module id = null
// module chunks = 